import { useState } from "react";
import { topicGroups, type TopicGroup } from "@/mocks/blackMaterial";

const toneMap: Record<string, string> = {
  primary: "text-primary-600",
  accent: "text-accent-600",
  secondary: "text-foreground-600",
};

const pillMap: Record<string, string> = {
  primary: "border-primary-200 bg-primary-50 text-primary-700 hover:bg-primary-100",
  accent: "border-accent-200 bg-accent-50 text-accent-800 hover:bg-accent-100",
  secondary: "border-secondary-200 bg-secondary-100/60 text-foreground-700 hover:bg-secondary-200",
};

export default function TopicWall() {
  const [active, setActive] = useState<TopicGroup>(topicGroups[0]);

  return (
    <section id="topics" className="bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 py-16 md:px-6 md:py-24">
        <div className="flex flex-col gap-3">
          <span className="text-xs font-semibold tracking-[0.18em] text-accent-600">主题索引</span>
          <h2 className="text-2xl font-bold text-foreground-950 md:text-4xl">人物话题墙</h2>
          <p className="max-w-2xl text-sm leading-7 text-foreground-500">
            按热度与把柄类型归堆，点开任一分区，就能快速锁定当下最被追问的那批黑料主角。
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-6 border-b border-background-200 pb-6 md:flex-row md:items-center md:justify-between">
          <div className="flex flex-wrap items-center gap-1 rounded-full bg-secondary-100/70 p-1">
            {topicGroups.map((g) => {
              const isActive = g.id === active.id;
              return (
                <button
                  key={g.id}
                  type="button"
                  onClick={() => setActive(g)}
                  className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors cursor-pointer ${
                    isActive
                      ? "bg-background-50 text-foreground-950 shadow-sm"
                      : "text-foreground-600 hover:text-foreground-900"
                  }`}
                >
                  {g.label}
                </button>
              );
            })}
          </div>
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <i className="ri-separator" />
            当前分区 · <span className="font-semibold text-foreground-800">{active.desc}</span>
          </div>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {active.topics.map((t) => (
            <a
              key={t.name}
              href="#ranking"
              className="group flex cursor-pointer items-center justify-between gap-3 rounded-lg border border-background-200 bg-background-100/40 p-4 transition-all hover:-translate-y-0.5 hover:border-background-300"
            >
              <span className="flex items-center gap-2 text-sm font-medium text-foreground-800">
                <i className={`ri-price-tag-3-line ${toneMap[t.tone ?? "secondary"]}`} />
                <span className="whitespace-nowrap">{t.name}</span>
              </span>
              <span className="flex items-center gap-2">
                <span className="text-xs text-foreground-400">{t.count} 条</span>
                <i className="ri-arrow-right-up-line text-accent-600 opacity-0 transition-opacity group-hover:opacity-100" />
              </span>
            </a>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap gap-2">
          {active.topics.slice(0, 4).map((t) => (
            <span
              key={`pill-${t.name}`}
              className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-3 py-1.5 text-xs ${pillMap[t.tone ?? "secondary"]}`}
            >
              <i className="ri-fire-fill text-[11px]" />
              {t.name}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}